<script>
import { categoryListMethod } from '@state/helpers'
export default {
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      show: true,
    }
  },
  methods: {
    ...categoryListMethod,
    ...categoryListMethod,
    deleteCategoryData() {
      const Data = {
        id: this.data._id,
      }
      this.deleteCategory({ Data }).then((data) => {
        this.isLoading = false
        this.$bvToast.toast('Category Deleted Successfully', {
          title: `Success`,
          toaster: 'b-toaster-top-right',
          solid: true,
          variant: 'success',
          appendToast: false,
        })
        setTimeout(() => {
          window.location.reload()
        }, 1500)
      })
    },
  },
}
</script>
<template>
  <div class="alert">
    <b-modal
      id="category-delete-modal"
      v-model="show"
      title="delete"
      ok-title="Delete"
      :hide-footer="false"
      @ok="deleteCategoryData"
    >
      <template v-slot:modal-title>
        <h4>Delete</h4>
      </template>
      <p>Are you sure you want to delete the {{ data.name }} ?</p>
    </b-modal>
  </div>
</template>
<style>
.btn-secondary {
  color: #545b62 !important;
  background-color: white !important;
  border-color: #ced4da !important;
}
</style>
